module.exports = __webpack_public_path__ + "img/arrow-down-used.2d7cba98.svg";